module.exports = __webpack_public_path__ + "img/character_frame_highlight.1c66cbe3.png";